import { Injectable } from '@angular/core';
import { thousandsFormat } from '../helpers/numbers.utils';

@Injectable({
  providedIn: 'root',
})
export class NumberUtilsService {
  /**
   * Formats a number with thousands separator
   * @param value - The number to format
   * @returns Formatted number string
   */
  thousandsFormat(value: number | string): string {
    return thousandsFormat(value);
  }
}
